import { render, staticRenderFns } from "./fee-base.vue?vue&type=template&id=270a9506&"
import script from "./fee-base.vue?vue&type=script&lang=ts&"
export * from "./fee-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports